import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CustomSidenavModule } from '../../shared/custom-sidenav/custom-sidenav.module';
import { DashboardTemplateModule } from './dashboard-template/dashboard-template.module';
import { RouterModule } from '@angular/router';
import { dashboardRouters } from './dashboard-routing.module';
import { DashboardTemplateComponent } from './dashboard-template/dashboard-template.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ButtonModule,
    DashboardTemplateModule,
    CustomSidenavModule,
    RouterModule.forChild(dashboardRouters)
  ],
  exports: []
})
export class DashboardModule {}
